<template>
  <section class="min-h-screen bg-white border-r">
    <section class="w-[88%] mx-auto py-4">
      <div class="flex items-center justify-between">
        <img src="@/assets/svg/ardovaLogo.svg" />
        <div class="block lg:hidden">
          <i
            @click="closeSidebar"
            class="pi pi-times"
            style="font-size: 1.5rem"
          ></i>
        </div>
      </div>

      <section class="my-8">
        <!-- dashboard link -->
        <div>
          <router-link
            class="flex items-center p-2 text-xs rounded-md cursor-pointer gap-x-4"
            :class="route === 'dashboard' ? active : inActive"
            :to="{ name: `Dashboard` }"
          >
            <div>
              <img
                :src="
                  route === 'dashboard'
                    ? require(`@/assets/svg/activeDash.svg`)
                    : require(`@/assets/svg/dashboardIcon.svg`)
                "
                class="w-5"
              />
            </div>
            <p class="">Dashboard</p>
          </router-link>
        </div>
        <!--  -->

        

        <section>
          <!-- general nav -->
          <GeneralNavs
            :navLink="navLink"
            :getNavIcon="getNavIcon"
            :modules="modules"
          />
          <!--  -->

          <!-- Reward link -->
        <div v-if="modules?.includes('cashback')">
          <router-link
            class="flex items-center p-2 text-xs rounded-md cursor-pointer gap-x-4"
            :class="route === 'reward' ? active : inActive"
            :to="{ name: `Reward` }"
          >
            <div>
              <img
                :src="
                  route === 'reward'
                    ? require(`@/assets/svg/activeDash.svg`)
                    : require(`@/assets/svg/dashboardIcon.svg`)
                "
                class="w-5"
              />
            </div>
            <p class="">Reward</p>
          </router-link>
        </div>

        <div v-if="modules?.includes('voucher')">
          <router-link
            class="flex items-center p-2 text-xs rounded-md cursor-pointer gap-x-4"
            :class="route === 'vouchers' ? active : inActive"
            :to="{ name: `Vouchers` }"
          >

            <div>
              <img
                :src="
                  route === 'vouchers'
                    ? require(`@/assets/svg/activeDash.svg`)
                    : require(`@/assets/svg/dashboardIcon.svg`)
                "
                class="w-5"
              />
            </div>
            <p class="">Vouchers</p>
          </router-link>
        </div>


        <!-- Feedback link -->
        <div v-if="modules?.includes('feedback')">
          <router-link
            class="flex items-center p-2 text-xs rounded-md cursor-pointer gap-x-4"
            :class="route === 'feedback' ? active : inActive"
            :to="{ name: `Feedback` }"
          >
            <div>
              <img
                :src="
                  route === 'feedback'
                    ? require(`@/assets/svg/activeDash.svg`)
                    : require(`@/assets/svg/dashboardIcon.svg`)
                "
                class="w-5"
              />
            </div>
            <p class="">Feedback</p>
          </router-link>
        </div>

        <!--  -->

          <!-- business nav -->
          <BusinessSidenavs
            :navLink="navLink"
            :getNavIcon="getNavIcon"
            :modules="modules"
          />
          <!--  -->

          <!-- customer nav -->
          <CustomerSidenavs
            :navLink="navLink"
            :getNavIcon="getNavIcon"
            :modules="modules"
          />
          <!--  -->

          <!-- other nav -->
          <OtherSidenavs
            :navLink="navLink"
            :getNavIcon="getNavIcon"
            :modules="modules"
          />
          <!--  -->
        </section>
      </section>
    </section>
  </section>
</template>

<script>
// import Vue from 'vue'

//utils
import { getUserToken } from "../../../utils/getUserToken";

//services
import sidebarService from "@/services/sidebar-service.js"; 

//components
import NavText from "../Text/NavText.vue";
import GeneralNavs from "@/components/UI/AutomatedSidebar/GeneralNav.vue";
import DropdownNav from "@/components/UI/AutomatedSidebar/DropdownNav.vue";
import OtherSidenavs from "@/components/UI/AutomatedSidebar/OtherSidenavs.vue";
import NoDropdownNav from "@/components/UI/AutomatedSidebar/NoDropdownNav.vue";
import CustomerSidenavs from "@/components/UI/AutomatedSidebar/CustomerSidenavs.vue";
import BusinessSidenavs from "@/components/UI/AutomatedSidebar/BusinessSidenavs.vue";
//assets

export default {
  name: "AutomatedSidebar",
  components: {
    NavText,
    GeneralNavs,
    DropdownNav,
    NoDropdownNav,
    OtherSidenavs,
    BusinessSidenavs,
    CustomerSidenavs,
  },
  data() {
    return {
      isUsersOpen: false,
      isInventoryOpen: false,
      isProgramOpen: false,
      isDealerOpen: false,
      userDetails: getUserToken(),
      modules: [],

      active: "text-white bg-black rounded-md ",
      inActive: "text-black",
      route: this.$route.name?.toLowerCase(),
      navLink: [],
      // navLink: JSON.parse(localStorage.getItem("navs") ?? []),
    };
  },
  computed: {
    // Dynamically select the icon based on the route name
    getIcon() {
      return (navItem) => {
        return this.route === navItem.link ? navItem.activeIcon : navItem.icon;
      };
    },
  },
  mounted() {
    this.navLink = localStorage.getItem("navs")
      ? JSON.parse(localStorage.getItem("navs"))
      : [];

    this.modules = localStorage.getItem("modules")
      ? JSON.parse(localStorage.getItem("modules"))
      : [];

    if (this.navLink?.length < 1) {
      this.getSidenav();
      this.getUserModule();
    }
  },
  methods: {
    //REQUESTS
    async getSidenav() {
      try {
        const result = await sidebarService.getSidenav();
        if (result) {
          this.navLink = result;
          localStorage.setItem("navs", JSON.stringify(result));
        }
      } catch (err) {
        console.log(err, "sidenav error");
      } finally {
        this.showLoader = false;
      }
    },

    async getUserModule() {
      try {
        const result = await sidebarService.getUserModule();
        if (result) {
          this.modules = result;

          localStorage.setItem("modules", JSON.stringify(result));
        }
      } catch (err) {
        console.log(err, "user module error");
      } finally {
        this.showLoader = false;
      }
    },

    //utilities

    getNavIcon(nav) {
      nav = nav.toLowerCase().replace(/\s+/g, "");
      const route = this.route.replace(" ", "");

      const navName = nav?.toLowerCase();
      if (route === navName) {
        console.log(`@/assets/svg/active${navName}.svg`);
        // console.log(route, navName);
      }
      try {
        let activeIcon, inactiveIcon;

        if (navName === "settings& control") {
          activeIcon = require(`@/assets/svg/settings.svg`);
          inactiveIcon = require(`@/assets/svg/settingsW.svg`);
        } else {
          activeIcon = require(`@/assets/svg/active${navName}.svg`);

          inactiveIcon = require(`@/assets/svg/inactive${navName}.svg`);
        }

        return route === nav ? activeIcon : inactiveIcon;
      } catch (err) {
        const activeIcon = require(`@/assets/svg/wallet.svg`);
        const inactiveIcon = require(`@/assets/svg/wallet.svg`);
        return route === nav ? activeIcon : inactiveIcon;
      }
    },

    toggleUserDropdown() {
      this.isUsersOpen = !this.isUsersOpen;
    },

    toggleInventoryDropdown() {
      this.isInventoryOpen = !this.isInventoryOpen;
    },

    toggleProgramDropdown() {
      this.isProgramOpen = !this.isProgramOpen;
    },

    toggleDealerDropdown() {
      this.isDealerOpen = !this.isDealerOpen;
    },

    getInventoryStatus() {
      const arrLinks = [
        "Stock Inventory",
        "Product Details",
        "Orders",
        "Order Details",
      ];

      let currentPage = arrLinks?.find((el) => el === this.route);

      return currentPage !== undefined ? true : this.isInventoryOpen;
    },

    getProgramStatus() {
      const arrLinks = [
        "Safety Check",
        "Schedule Truck",
        "Program List",
        "Uliage Trucks",
        "Waybill Trucks",
        "Truck Uliage",
        "Program Truck",
      ];

      let currentPage = arrLinks?.find((el) => el === this.route);

      return currentPage !== undefined ? true : this.isProgramOpen;
    },

    getDealerStatus() {
      const arrLinks = ["Dealer Order Request", "Dealer Orders"];

      let currentPage = arrLinks?.find((el) => el === this.route);

      return currentPage !== undefined ? true : this.isDealerOpen;
    },

    getUserStatus() {
      const arrLinks = [
        "Business",
        "Business Details",
        "Business Approve",
        "Users",
        "Individual Details",
      ];

      let currentPage = arrLinks?.find((el) => el === this.route);

      return currentPage !== undefined ? true : this.isUsersOpen;
    },

    closeSidebar() {
      this.$store.dispatch("closeSidebar");
    },
  },
};
</script>

<style></style>
